var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-collection-card',{attrs:{"title":"Customer Retention","subtitle":"Customers who bought on the different dates (anytime)","data":_vm.customers,"loading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }